import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export type ByokKey = {
  id: string;
  provider: 'openai' | 'gemini';
  label: string | null;
  created_at: number;
  key_hint: string | null;
};

export function useByokKeys() {
  return useQuery({
    queryKey: ['byok'],
    queryFn: () => api.get<{ keys: ByokKey[] }>('/api/app/byok'),
  });
}

export function useAddByok() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { provider: 'openai' | 'gemini'; key: string; label?: string }) =>
      api.post<{ id: string }>('/api/app/byok', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['byok'] }),
  });
}

export function useTestByok() {
  return useMutation({
    mutationFn: (body: { provider: 'openai' | 'gemini'; key: string }) =>
      api.post<{ ok: boolean; message: string }>('/api/app/byok/test', body),
  });
}

export function useDeleteByok() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.del<{ deleted: boolean }>(`/api/app/byok/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['byok'] }),
  });
}
